const resources = {
  en: {
    passkeys: {
      title: 'Passkeys',
      subtitle: 'Manage the devices that can verify your sign-in.',
      cardTitle: 'Saved passkeys',
      empty: 'No passkeys saved yet.',
      never: 'Never used',
      note: 'Passkeys stay on your device. FinApp stores only safe management metadata and never shows credential secrets.',
      actions: {
        add: 'Add passkey',
        refresh: 'Refresh',
        rename: 'Rename',
        remove: 'Remove',
      },
      summary: {
        count: '{{count}} passkey',
        count_plural: '{{count}} passkeys',
        updated: 'Last updated {{date}}',
      },
      fields: {
        createdAt: 'Added {{date}}',
        lastUsedAt: 'Last used {{date}}',
        transports: 'Device type: {{value}}',
      },
      tags: {
        recent: 'Recently used',
      },
      unsupported: {
        title: 'Passkeys are not available in this browser',
        description: 'Open FinApp in a browser or device that supports passkeys to add a new one.',
      },
      deleteConfirm: {
        title: 'Remove this passkey?',
        description: 'You can still sign in with email verification or another saved passkey.',
        ok: 'Remove',
        cancel: 'Cancel',
      },
      renameModal: {
        title: 'Rename passkey',
        description: 'Use a short name that helps you recognize the device.',
        placeholder: 'My iPhone',
        save: 'Save',
        cancel: 'Cancel',
      },
      messages: {
        added: 'Passkey added.',
        renamed: 'Passkey renamed.',
        deleted: 'Passkey removed.',
        cancelled: 'Passkey setup was cancelled.',
      },
      errors: {
        title: 'Passkey action failed',
        load: 'Unable to load passkeys',
        add: 'Unable to add passkey',
        rename: 'Unable to rename passkey',
        delete: 'Unable to remove passkey',
      },
    },
  },
  uk: {
    passkeys: {
      title: 'Пасключі',
      subtitle: 'Керуйте пристроями, які можуть підтверджувати ваш вхід.',
      cardTitle: 'Збережені пасключі',
      empty: 'Пасключів ще немає.',
      never: 'Ще не використовувався',
      note: 'Пасключі залишаються на вашому пристрої. FinApp зберігає лише безпечні метадані для керування і не показує секрети облікових даних.',
      actions: {
        add: 'Додати пасключ',
        refresh: 'Оновити',
        rename: 'Перейменувати',
        remove: 'Видалити',
      },
      summary: {
        count: '{{count}} пасключ',
        count_plural: '{{count}} пасключів',
        updated: 'Оновлено {{date}}',
      },
      fields: {
        createdAt: 'Додано {{date}}',
        lastUsedAt: 'Востаннє використано {{date}}',
        transports: 'Тип пристрою: {{value}}',
      },
      tags: {
        recent: 'Нещодавно використано',
      },
      unsupported: {
        title: 'Пасключі недоступні в цьому браузері',
        description: 'Відкрийте FinApp у браузері або на пристрої з підтримкою пасключів, щоб додати новий.',
      },
      deleteConfirm: {
        title: 'Видалити цей пасключ?',
        description: 'Ви все ще зможете увійти через email-підтвердження або інший збережений пасключ.',
        ok: 'Видалити',
        cancel: 'Скасувати',
      },
      renameModal: {
        title: 'Перейменувати пасключ',
        description: 'Вкажіть коротку назву, щоб легко впізнати пристрій.',
        placeholder: 'Мій iPhone',
        save: 'Зберегти',
        cancel: 'Скасувати',
      },
      messages: {
        added: 'Пасключ додано.',
        renamed: 'Пасключ перейменовано.',
        deleted: 'Пасключ видалено.',
        cancelled: 'Налаштування пасключа скасовано.',
      },
      errors: {
        title: 'Дія з пасключем не виконана',
        load: 'Не вдалося завантажити пасключі',
        add: 'Не вдалося додати пасключ',
        rename: 'Не вдалося перейменувати пасключ',
        delete: 'Не вдалося видалити пасключ',
      },
    },
  },
}

export default resources
